import React from 'react';
import ReactDOM from 'react-dom';
import { WebXMex } from './WebXMex';
import './styles/styles.scss';

ReactDOM.render(<WebXMex />, document.getElementById('root'));
